import { React, useEffect, useState, Fragment } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";

import * as roleService from "../api/api";
import MyCard from '../../../shared/components/myCard'
import CircularProgress from '@mui/material/CircularProgress';
import { toast } from "react-toastify";

import EditPopupForm from "./editPopupForm";

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

// Material UI
import { Box, Button, TextField } from '@mui/material';

const EditCommandCell = (props) => {
    return (
        <td>
            <button
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                onClick={() => props.enterEdit(props.dataItem)}
            >
                Güncelle
            </button>
        </td>
    );
};

const Role = () => {
    const defaultInputValues = {
        name: ''
    };

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Rol adı girilmesi gereklidir')
    });

    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        getValues,
    } = useForm({ defaultValues: defaultInputValues, resolver: yupResolver(validationSchema) });


    const [openForm, setOpenForm] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [editItem, setEditItem] = useState({

    });
    const [RoleList, setRoleList] = useState([]);
    //const [newCountry, setNewCountry] = useState("");

    const enterEdit = (item) => {
        setOpenForm(true);
        setEditItem(item);
    };

    const handleRoleSubmit = (name, id) => {
        updateRole(name, id);
        setOpenForm(false);
    };

    const handleCancelEdit = () => {
        setOpenForm(false);
    };

    const MyEditCommandCell = (props) => (
        <EditCommandCell {...props} enterEdit={enterEdit} />
    );

    useEffect(() => {
        // getToken();
        getRoleList();

    }, []);

    function handleAddRole() {
        addRole(getValues("name"));
    }



    function updateRole(vl, id) {
        const Role = {
            "id": id,
            "name": vl
        };
        roleService.update(Role).then((res) => {
            const { isSuccess,message } = res;
            if (isSuccess) {
                toast.success("Role guncellendi.");
                getRoleList();
            } else {
                toast.error(message);
                console.log(res, "updateRole-hata");
            }
        });
    }


    function addRole(vl) {
        const Role = {

            "name": vl
        };
        roleService.create(Role).then((res) => {
            const { isSuccess,message } = res;
            if (isSuccess) {
                getRoleList();
                toast.success("Role eklendi.");
                setValue('name', '');
            } else {
                toast.error(message);
                console.log(res, "addRole-hata");
            }
        });
    }


    function getRoleList() {
        setIsLoading(true);
        const pagerInputModel = {
            "pageNumber": 1,
            "pageSize": 100

        };
        roleService.list(pagerInputModel).then((res) => {
            const { isSuccess,message, data: RoleData } = res;
            if (isSuccess) {
                setRoleList(RoleData);

            } else {
                toast.error(message);
                console.log(res, "getRoleList-hata");
            }
            setIsLoading(false);
        });
    }
    return (
        <Fragment>
           
            <MyCard header="Rol Ekle">
                <Box component="span" sx={{ pl: 2 }}>
                    <TextField
                        required
                        id="outlined-required"
                        label="Rol Adı"
                        error={errors.name ? true : false}
                        helperText={errors.name?.message}
                        {...register('name')}
                        size="small"
                    />
                </Box>
                <Box component="span" sx={{ pl: 2 }}>
                    <Button onClick={handleSubmit(handleAddRole)} variant="outlined">Ekle</Button>
                </Box>
            </MyCard>

            {isLoading ? <CircularProgress /> :
                <MyCard header="Rol Listesi">

                    <Grid
                        style={{
                            height: "400px",
                            width: "500px"
                        }}
                        data={RoleList}
                    >
                        <Column field="id" title="ID" width="40px" />
                        <Column field="name" title="AD" width="250px" />
                        <Column cell={MyEditCommandCell} />
                    </Grid>
                    {openForm && (
                        <EditPopupForm

                            cancelEdit={handleCancelEdit}
                            onSubmit={handleRoleSubmit}
                            item={editItem}
                        />
                    )}
                </MyCard>
            }
        </Fragment>
    );
};

export default Role;